import TermsOfService from '@/components/TermsOfService';
import Footer from '@/components/Footer';

export default function TermsOfServicePage() {
  return (
    <div className="pt-20">
      <TermsOfService />
      <Footer />
    </div>
  );
}
